var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingFeatureAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 22.3337C14.6025 22.3337 18.3334 18.6027 18.3334 14.0003C18.3334 9.39795 14.6025 5.66699 10.0001 5.66699C5.39771 5.66699 1.66675 9.39795 1.66675 14.0003C1.66675 18.6027 5.39771 22.3337 10.0001 22.3337ZM11.0417 10.8753C11.0417 10.3 10.5754 9.83366 10.0001 9.83366C9.42478 9.83366 8.95841 10.3 8.95841 10.8753V12.9587H6.87508C6.29978 12.9587 5.83341 13.425 5.83341 14.0003C5.83341 14.5756 6.29978 15.042 6.87508 15.042H8.95841V17.1253C8.95841 17.7006 9.42478 18.167 10.0001 18.167C10.5754 18.167 11.0417 17.7006 11.0417 17.1253V15.042H13.1251C13.7004 15.042 14.1667 14.5756 14.1667 14.0003C14.1667 13.425 13.7004 12.9587 13.1251 12.9587H11.0417V10.8753Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingFeatureAdd);
export default __webpack_public_path__ + "static/media/onboarding-feature-add.7b5b987ed999afdaf463961d62766059.svg";
export { ForwardRef as ReactComponent };